import { useEffect, useState } from 'react';
import { isAppDestination, navigateToApp } from './appNavigation';

export function AppNavigationBridge() {
  const [state, setState] = useState<{ pending?: boolean; error?: string; retry?: string }>({});
  useEffect(() => {
    const click = (event: MouseEvent) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const anchor = event.target instanceof Element ? event.target.closest('a[href]') : null;
      if (!(anchor instanceof HTMLAnchorElement) || anchor.hasAttribute('download') || !isAppDestination(anchor.href)) return;
      event.preventDefault();
      event.stopPropagation();
      void navigateToApp(anchor.href);
    };
    const update = (event: Event) => setState((event as CustomEvent).detail);
    document.addEventListener('click', click, true);
    window.addEventListener('beaw-app-navigation', update);
    return () => {
      document.removeEventListener('click', click, true);
      window.removeEventListener('beaw-app-navigation', update);
    };
  }, []);
  if (!state.pending && !state.error) return null;
  return <div role={state.error ? 'alert' : 'status'} style={{ position: 'fixed', inset: 'auto 16px 24px', zIndex: 10000, padding: 16, background: '#fff', color: '#00357f', borderRadius: 16, boxShadow: '0 4px 24px #0003' }}>
    {state.pending ? 'กำลังเปิด Beaw…' : <>{state.error} <button onClick={() => void navigateToApp(state.retry)}>ลองอีกครั้ง</button> <button onClick={() => setState({})}>ปิด</button></>}
  </div>;
}
